/**
 * SaudacaoDoInicio — cabeçalho do Início do portal do parceiro (PR 5).
 *
 * A saudação que o Dashboard fazia (nome + razão social): o Dashboard passa a
 * ser página própria e o parceiro cai aqui. Sem nome, só a saudação — nunca
 * "Olá, undefined".
 *
 * S6 (revisão de design, 19/09/2026) — era "Bem-vindo, {nome}", herdado do
 * Dashboard: saudação no masculino na primeira linha da página, num portal
 * cheio de donas de loja (a própria conta de teste é `dona@`). "Olá" não tem
 * gênero e é mais curto.
 */

export interface SaudacaoDoInicioProps {
  nome?: string | null;
  razaoSocial?: string | null;
}

export function SaudacaoDoInicio({ nome, razaoSocial }: SaudacaoDoInicioProps) {
  const nomeLimpo = nome?.trim();
  const razaoLimpa = razaoSocial?.trim();

  return (
    <header data-testid="inicio-saudacao">
      <h1 className="text-2xl font-bold tracking-tight text-emerald-900 sm:text-3xl">
        Olá
        {nomeLimpo ? (
          <>
            , <span className="text-emerald-700">{nomeLimpo}</span>
          </>
        ) : null}
      </h1>
      {/* Sem razão social, o nome do produto — igual ao Dashboard de hoje. */}
      <p className="mt-1 text-sm text-slate-600">{razaoLimpa || "Portal do Parceiro"}</p>
    </header>
  );
}

export default SaudacaoDoInicio;
